import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import ItemQVSIHRow from './ItemQVSIHRow';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import { UiViewContent, UiView } from "../../../../library/layout/Index";

const ItemQV = (props) => {
    const { formObject, viewData } = props;

    return (
        <>
          <UiView>
            <UiViewContent>
                <ul className="uiListTable" style={{backgroundColor:"#FFF", width:"max-content"}}>
                    <li className="uiSearchHeading">
                        <ul>
                            <li className="uiColumnCenter uiColumn200"><SarasTrans value="Location" /></li>
                            <li className="uiColumnCenter uiColumn90"><SarasTrans value="Person" /></li>
                            <li className="uiColumnCenter uiColumn70"><SarasTrans value="SIH" /></li>
                        </ul>
                    </li>
                    {
                        Object.values(viewData ? viewData : {}).map((row, index) => (
                            <li><ItemQVSIHRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} index={index + 1} /></li>
                        ))
                    }
                </ul>
            </UiViewContent>
        </UiView>  
        </>
    )
}

export default withView(ItemQV, "","");